import logging from '../../service/logging';

const setItem = (key: string, value: string): void => {
   try {
      window.localStorage.setItem(key, value);
   } catch (e) {
      logging.error(`Failed to set local storage key: ${key} with value: ${value}.`, e);
   }
};

const getItem = (key: string): string => {
   try {
      return window.localStorage.getItem(key) || '';
   } catch (e) {
      logging.error(`Failed to get local storage key: ${key}.`, e);
      return '';
   }
};

const removeItem = (key: string): void => {
   try {
      window.localStorage.removeItem(key);
   } catch (e) {
      logging.error(`Failed to remove local storage key: ${key}.`, e);
   }
};

export default {
   setItem,
   getItem,
   removeItem
};
